import React, { FC, CSSProperties } from 'react';
import s from './Button.module.css';

type ButtonType = 'primary' | 'secondary' | 'tertiary' | 'text';
type ButtonState = 'enabled' | 'disabled' | 'loading';
type IconPosition = 'left' | 'right';

interface ButtonProps {
    text?: string;
    onClick: (e:any) => void;
    type?: ButtonType;
    state?: ButtonState;
    style?: CSSProperties;
    icon?: string;
    iconPosition?: IconPosition;

}

const Button: FC<ButtonProps> = ({
                                     text,
                                     onClick,
                                     type = 'primary',
                                     state = 'enabled',
                                     style,
                                     icon,
                                     iconPosition = 'left',
                                 }) => {
    const buttonClass = `${s.button} ${s[type]} ${s[state]}`;
    const iconClass = iconPosition === 'left' ? s.iconLeft : s.icon;

    return (
        <div className={s.background}>
            <button
                type="button"
                onClick={onClick}
                className={buttonClass}
                style={{...style}}
                disabled={state === 'disabled' || state === 'loading'}
            >
                {icon && iconPosition === 'left' && <img src={icon} alt="" className={iconClass}/>}
                {state === 'loading' ? (
                    <div className={s.spinner}></div>
                ) : (
                    text
                )}
                {icon && iconPosition === 'right' && <img src={icon} alt="" className={iconClass}/>}
            </button>
        </div>

    );
};

export default Button;
